<template>
  <div class="lottery-page">
    <HeroCarousel :slides="heroSlides" />

    <NoticeBar @domain-loaded="onDomainLoaded" />
  <div class="box pad"><meta http-equiv="Content-Type" content="text/html; charset=utf-8">

  <table class="table1 fontb dkzlw" style="background:#FFF" width="100%" border="0" cellspacing="0" cellpadding="0">
    <tbody>
	<tr>
      <th>↓↓↓ 以下网址均可打开<font color="#FF0000">本网站</font> ↓↓↓</th>
    </tr>
   <tr>
      <td><font color="#FF0000"></font>唯一官网<span class="webblack">{{ siteDomain }}</span></td>
    </tr>
    <tr>
      <td>任意数字或字母组合<span class="webblue">.{{ siteDomain }}</span>访问</td>
    </tr>
    <tr>
      <td><font color="#843fa1">本站启用自定义域名→快捷进站</font></td>
    </tr>
    <tr>
      <td><font color="#e67e23">在网址前任意添加一个或者多个</font></td>
    </tr>
    <tr>
      <td><font color="#ff0000">字母或数字均可打开论坛</font></td>
    </tr>
    <tr>
    <td><font color="#ec0659">要想别墅靠大海，赶快来买六合彩</font></td>
    </tr>
  <tr>
    <td><font color="#ec0659">要想发家又致富，每期都要下重注！！！</font></td>
  </tr>
    <tr>
      <td>
      </td>
    </tr>
  </tbody>
  </table>
  </div>
    <section class="result-card">
      <div class="game-tabs">
        <button
          v-for="g in games"
          :key="g.id"
          type="button"
          class="game-tabs__btn"
          :class="{ 'is-active': activeId === g.id }"
          @click="activeId = g.id"
        >{{ g.label }}</button>
      </div>

      <div class="result-card__content">
        <div class="result-card__head">
          <h2 class="result-card__title">第 <span style="color: red;">{{ displayResultCardIssue }}</span> 期开奖结果</h2>
          <div class="result-card__links">
            <router-link class="link-red" :to="{ path: '/history', query: { game: activeId } }">历史记录</router-link>
          </div>
        </div>

        <div class="result-card__numbers-row">
          <BallDisplay
            :mainNumbers="displayDraw.mainNumbers"
            :special="displayDraw.special"
            :drawPhaseNear="drawPhaseNear"
            :pollSlotRevealed="pollSlotRevealed"
            :drawRevealed="effectiveDrawRevealed"
            :isLiveDrawing="isLiveDrawing"
            :drawingChars="drawingChars"
            :ballTone="ballTone"
          />
        </div>

        <p class="result-card__next">
          <template v-if="current.nextDrawDeadlineMs">
            
            <span style="color: black;">下一期 · 开奖倒计时&nbsp;&nbsp;</span>
            <strong class="countdown-num">{{ countdownText }}</strong>
          </template>
        
        </p>
      </div>
    </section>

    <PromoImages />

    <!-- <PredictionTable /> -->

    <!-- <K14nfbPanel /> -->

 <!--   <PictureGallery
      v-if="pictureGalleryLotteryType != null"
      ref="pictureGallery"
      :lotteryType="pictureGalleryLotteryType"
      @open-preview="openPicturePreview"
    /> -->

    <!-- <video width="50%" height="100px" >

    </video> -->

    <!-- <video controls width="50%" height="160">
      <source src="http://video.suyuan1688.com/lottery/video/2026/2032/2026131.mp4" >
  
  您的浏览器不支持 HTML5 video 标签。
  </video> -->
    <!-- <LiveStream
      v-if="activeId === 'macau'"
      :streamUrl="displayLiveStreamUrl"
      :isHls="liveStreamIsHls"
    /> -->

    <section v-for="panel in bbsVisible" :key="panel.file" class="bbs-panel" v-html="panel.html"></section>

    <button type="button" class="fab-refresh" aria-label="回到顶部" @click="scrollToTop"><img src="/images/goTop.png" alt="顶部" class="fab-img" /></button>

    <PicturePreviewModal
      :preview="picturePreview"
      @close="closePicturePreview"
    />
  
  
  <iframe
    v-if="iframeSrc"
    ref="iframe"
    class="mus55-iframe"
    :src="iframeSrc"
    frameborder="0"
  ></iframe>
  
  </div>

</template>

<script>
import { fetchLatestDraw as requestLatestDraw, fetchDrawsPage } from '@/api/draw'
import { fetchLotteryTypesList } from '@/api/lotteryTypes'
import { fetchZodiacMap } from '@/api/meta'
import { heroSlides, buildGames, makeGameFromBackend, waveTables, POST_DRAW_POLL_DEADLINE_GRACE_MS } from '@/config/gameConfig'
import { waveTone } from '@/utils/ballUtils'
import { mapApiToDraw, mapYuexiawangApiToDraw, mapHkLotteryApiToDraw, buildDrawFromOpenStyle, hasOpenStyleDataForFill, isOpenStyleResultComplete } from '@/services/apiAdapters'
import { mapRecordToRow } from '@/services/historyAdapters'
import { extractPagePayload } from '@/utils/httpUtils'
import http from '@/api/http'

import HeroCarousel from '@/components/lottery/HeroCarousel.vue'
import BallDisplay from '@/components/lottery/BallDisplay.vue'
// import PictureGallery from '@/components/lottery/PictureGallery.vue'
import PicturePreviewModal from '@/components/lottery/PicturePreviewModal.vue'
import PromoImages from '@/components/lottery/PromoImages.vue'
import NoticeBar from '@/components/lottery/NoticeBar.vue'
// import PredictionTable from '@/components/lottery/PredictionTable.vue'
// import LiveStream from '@/components/lottery/LiveStream.vue'
// import K14nfbPanel from '@/components/lottery/K14nfbPanel.vue'

export default {
  name: 'HomePage',
  components: { HeroCarousel, BallDisplay, PicturePreviewModal, PromoImages, NoticeBar },
  data() {
    return {
      heroSlides,
      siteDomain: '',
      activeId: '',
      games: buildGames([]),
      drawLoadError: null,
      countdownText: '',
      countdownTimerId: null,
      drawPhaseNear: false,
      drawingChars: ['正','在','进','行','开','奖','中'],
      drawPollTimerId: null,
      drawPollGameId: null,
      drawPollBaseline: null,
      drawPollInFlight: false,
      drawPollAttempts: 0,
      pollSlotRevealed: null,
      zodiacMap: null,
      pictureGalleryLotteryType: null,
      picturePreview: null,
      previousDraws: {},
      bbsPanels: [],
      iframeSrc: '',
    }
  },
  computed: {
    bbsVisible() { return this.bbsPanels.filter(p => p.html) },
    activeGame() { return this.games.find(g => g.id === this.activeId) || this.games[0] },
      bbsFiles() { return this.activeGame?.bbsFiles || [] },
    current() { return this.activeGame.draw },
    previousDraw() { return this.previousDraws[this.activeId] || null },
    displayDraw() { return this.showPreviousInstead && this.previousDraw ? this.previousDraw : this.current },
    revealedCount() {
      const d = this.current
      if (!d) return 0
      if (Array.isArray(d.revealed)) return d.revealed.filter(Boolean).length
      const mains = Array.isArray(d.mainNumbers) ? d.mainNumbers : []
      const mainCount = mains.filter(b => b && b.value != null && String(b.value).trim() !== '').length
      const sp = d.special && d.special.value != null && String(d.special.value).trim() !== '' ? 1 : 0
      return mainCount + sp
    },
    isFullyRevealed() { return this.revealedCount >= 7 },
    isLiveDrawing() { return this.revealedCount > 0 && !this.isFullyRevealed },
    effectiveDrawRevealed() {
      const d = this.displayDraw
      if (!d) return null
      if (Array.isArray(d.revealed)) return d.revealed
      const mains = Array.isArray(d.mainNumbers) ? d.mainNumbers : []
      const r = []
      for (let i = 0; i < 6; i++) {
        const b = mains[i]
        r.push(!!(b && b.value != null && String(b.value).trim() !== ''))
      }
      const sp = d.special
      r.push(!!(sp && sp.value != null && String(sp.value).trim() !== ''))
      return r
    },
    isInDrawingWindow() {
      const end = this.current && this.current.nextDrawDeadlineMs
      if (end == null || !Number.isFinite(end)) return false
      const off = end - Date.now()
      return off <= 3 * 60 * 1000 && off >= -15 * 60 * 1000
    },
    isDrawing() {
      return this.revealedCount === 0 && !this.isFullyRevealed && this.isInDrawingWindow
    },
    showPreviousInstead() {
      return !!(this.current && this.current.issue) &&
        this.revealedCount === 0 &&
        !this.isFullyRevealed &&
        !this.isDrawing &&
        !this.drawPhaseNear &&
        !!this.previousDraw
    },
    displayLiveStreamUrl() {
      const u = this.activeGame.liveStreamUrl
      return (u != null && String(u).trim() !== '') ? String(u).trim() : ''
    },
    liveStreamIsHls() { return this.displayLiveStreamUrl.toLowerCase().includes('.m3u8') },
    displayResultCardIssue() {
      if (this.showPreviousInstead && this.previousDraw) return this.previousDraw.issue
      const d = this.current
      if (!d) return ''
      const end = d.nextDrawDeadlineMs
      if (end == null || !Number.isFinite(end)) return d.issue
      const diff = end - Date.now()
      if (diff > 0 && diff <= 3 * 60 * 1000) {
        const nd = d.nextIssueDisplay
        if (nd != null && String(nd).trim() !== '' && nd !== '—') return nd
        const ni = d.nextIssue
        if (ni != null && String(ni).trim() !== '' && ni !== '—') return ni
      }
      // 数据全空 + 还未到 drawPhaseNear 窗口 → 沿用上期期号
      if (!this.drawPhaseNear && diff > 0 && this.revealedCount === 0 && this.previousDraw) {
        return this.previousDraw.issue
      }
      return d.issue
    },
    activePictureLotteryType() {
      return this.activeGame?.pictureLotteryType ?? null
    },
  },
  watch: {
    activeId() {
      this.closePicturePreview()
      this.clearPostDrawPoll()
      this.fetchBbsContent()
      this.initDraw()
      this.syncPictureGalleryTypeFromGame()
    },
    current: { handler() { this.restartCountdownTimer() }, deep: true },
  },
  mounted() {
    this.activeId = this.games[0]?.id || ''
    fetchLotteryTypesList().then(res => {
      const list = res.data?.data?.list
      if (Array.isArray(list) && list.length > 0) {
        const existingIds = new Set(this.games.map(g => g.id))
        const newIds = []
        for (let i = list.length - 1; i >= 0; i--) {
          if (!existingIds.has(list[i].code)) {
            this.games.splice(1, 0, makeGameFromBackend(list[i]))
            newIds.push(list[i].code)
          }
        }
        this.activeId = this.games[0]?.id || ''
        newIds.forEach(id => {
          if (id !== this.activeId) this.fetchLatestDraw(id, { silent: true })
        })
      }
    }).catch(() => {})
    fetchZodiacMap().then(res => {
      if (res.data && res.data.code === 200 && res.data.data && res.data.data.map) {
        this.zodiacMap = res.data.data.map
      }
    }).catch(() => {})
    this.preloadOtherGames()
    const loadIframe = () => {
      this.iframeSrc = 'https://dxw-0529.www01490168c.com:2053/sx.htm'
    }
    if (document.readyState === 'complete') {
      setTimeout(loadIframe, 500)
    } else {
      window.addEventListener('load', () => setTimeout(loadIframe, 500))
    }
  },
  beforeDestroy() {
    this.clearCountdownTimer()
    this.clearPostDrawPoll()
  },
  methods: {
    resolveDrawHttpRequest(game, options = {}) {
      const dr = game && game.drawRequest
      if (!dr || !dr.url) return null
      const afterDeadline = options.afterDeadline === true
      const resultUrl = (game.resultUrl && String(game.resultUrl).trim()) || ''
      let url, params
      if (afterDeadline && resultUrl) {
        url = resultUrl; params = { ...(dr.params || {}) }
      } else {
        url = dr.url; params = dr.params ? { ...dr.params } : {}
      }
      const isExternal = /^https?:\/\//i.test(url)
      return {
        url, method: dr.method || 'get', params, data: dr.data,
        headers: isExternal ? { Accept: '*/*' } : undefined
      }
    },

    async fetchLatestDraw(gameId, options = {}) {
      const silent = options.silent === true
      const afterDeadline = options.afterDeadline === true
      const id = gameId != null ? gameId : this.activeId
      const game = this.games.find(g => g.id === id)
      if (!game || !game.drawRequest || !game.drawRequest.url) return { ok: false }
      const httpReq = this.resolveDrawHttpRequest(game, { afterDeadline })
      if (!httpReq || !httpReq.url) return { ok: false }
      if (!silent) this.drawLoadError = null
      try {
        const res = await requestLatestDraw(httpReq)
        const data = res.data
        let payload = null
        if (Array.isArray(data)) { payload = data.length > 0 ? data[0] : null }
        else if (data && typeof data === 'object') {
          if (data.success === false || (data.code != null && Number(data.code) !== 200)) {
            throw new Error(data.msg || data.message || '接口返回失败')
          }
          if (data.data != null) {
            const inner = data.data
            payload = inner && typeof inner === 'object' && inner.data != null ? inner.data : inner
          } else { payload = data }
        }
        if (payload == null) {
          if (!silent) this.drawLoadError = '接口无数据'
          return { ok: false }
        }
        const schedule = game.drawSchedule || 'daily'

        if (Array.isArray(payload.body) && payload.body.length >= 9) {
          const draw = mapHkLotteryApiToDraw(payload, waveTables)
          if (!draw) {
            if (afterDeadline) return { ok: true, pollComplete: false }
            if (!silent) this.drawLoadError = '接口数据格式无法解析'
            return { ok: false }
          }
          if (this.zodiacMap) {
            const applyZodiac = (ball) => {
              if (!ball.value) return
              const key = String(parseInt(ball.value, 10))
              if (this.zodiacMap[key]) ball.zodiac = this.zodiacMap[key]
            }
            draw.mainNumbers.forEach(applyZodiac)
            applyZodiac(draw.special)
          }
          if (this.shouldSetDraw(id, draw)) this.$set(game, 'draw', draw)
          if (draw.revealed) {
            if (this.pollSlotRevealed == null) {
              this.pollSlotRevealed = [false,false,false,false,false,false,false]
            }
            for (let i = 0; i < 7; i++) {
              if (draw.revealed[i]) this.$set(this.pollSlotRevealed, i, true)
            }
          }
          const allRevealed = draw.revealed && draw.revealed.every(Boolean)
          return { ok: true, pollComplete: afterDeadline && allRevealed }
        }

        if (payload.k && typeof payload.k === 'string') {
          const draw = mapYuexiawangApiToDraw(payload, waveTables)
          if (!draw) {
            if (afterDeadline) return { ok: true, pollComplete: false }
            if (!silent) this.drawLoadError = '接口数据格式无法解析'
            return { ok: false }
          }
          // 应用生肖映射
          if (this.zodiacMap) {
            const applyZodiac = (ball) => {
              if (!ball.value) return
              const key = String(parseInt(ball.value, 10))
              if (this.zodiacMap[key]) ball.zodiac = this.zodiacMap[key]
            }
            draw.mainNumbers.forEach(applyZodiac)
            applyZodiac(draw.special)
          }
          if (this.shouldSetDraw(id, draw)) this.$set(game, 'draw', draw)
          if (draw.revealed) {
            if (this.pollSlotRevealed == null) {
              this.pollSlotRevealed = [false,false,false,false,false,false,false]
            }
            for (let i = 0; i < 7; i++) {
              if (draw.revealed[i]) this.$set(this.pollSlotRevealed, i, true)
            }
          }
          const allRevealed = draw.revealed && draw.revealed.every(Boolean)
          return { ok: true, pollComplete: afterDeadline && allRevealed }
        }

        const useOpenTimeAsDeadline = game.useOpenTimeAsDeadline === true
        const openStyleComplete = isOpenStyleResultComplete(payload)
        let draw = null
        if (hasOpenStyleDataForFill(payload) || useOpenTimeAsDeadline) {
          draw = buildDrawFromOpenStyle(payload, schedule, game.draw, waveTables, {
            afterDeadline,
            openStyleComplete,
            useOpenTimeAsDeadline
          })
        }
        if (!draw) { draw = mapApiToDraw(payload, schedule) }
        if (!draw) {
          if (!silent) this.drawLoadError = '接口数据格式无法解析'
          return { ok: false }
        }
        if (this.shouldSetDraw(id, draw)) this.$set(game, 'draw', draw)
        if (draw.revealed) {
          if (this.pollSlotRevealed == null) {
            this.pollSlotRevealed = [false,false,false,false,false,false,false]
          }
          for (let i = 0; i < 7; i++) {
            if (draw.revealed[i]) this.$set(this.pollSlotRevealed, i, true)
          }
        }
        return { ok: true, pollComplete: afterDeadline && openStyleComplete }
      } catch (e) {
        const msg = (e.response && e.response.data && e.response.data.msg) || e.message || '请求失败'
        if (!silent) this.drawLoadError = msg
        return { ok: false }
      }
    },

    clearCountdownTimer() {
      if (this.countdownTimerId != null) { clearInterval(this.countdownTimerId); this.countdownTimerId = null }
    },
    restartCountdownTimer() {
      this.clearCountdownTimer()
      this.tickCountdown()
      this.countdownTimerId = setInterval(() => this.tickCountdown(), 1000)
    },
    tickCountdown() {
      const end = this.current && this.current.nextDrawDeadlineMs
      if (end == null || !Number.isFinite(end)) {
        this.countdownText = ''; this.drawPhaseNear = false
        if (this.drawPollTimerId == null) this.clearPostDrawPoll()
        return
      }
      const diff = end - Date.now()
      if (diff > 0) {
        if (this.drawPollTimerId == null) this.clearPostDrawPoll()
        this.drawPhaseNear = diff <= 5 * 60 * 1000
        if (diff <= 30000) {
          this.startPostDrawPollIfNeeded()
        }
        const sec = Math.floor(diff / 1000)
        const days = Math.floor(sec / 86400)
        const h = Math.floor((sec % 86400) / 3600)
        const m = Math.floor((sec % 3600) / 60)
        const s = sec % 60
        const pad = n => String(n).padStart(2, '0')
        this.countdownText = days > 0 ? `${days}天 ${pad(h)}:${pad(m)}:${pad(s)}` : `${pad(h)}:${pad(m)}:${pad(s)}`
        return
      }
      this.countdownText = '00:00:00'; this.drawPhaseNear = false
      this.startPostDrawPollIfNeeded()
    },

    makeDrawBaselineSnapshot(draw) {
      if (!draw) return null
      const mains = (draw.mainNumbers || []).map(b => String(b.value ?? '')).join(',')
      const sp = draw.special ? String(draw.special.value ?? '') : ''
      return { issue: String(draw.issue || ''), sig: `${mains}|${sp}`, deadlineMs: draw.nextDrawDeadlineMs }
    },
    isDrawUpdatedSinceBaseline(baseline, draw) {
      if (!baseline || !draw) return false
      if (String(draw.issue || '') !== baseline.issue) return true
      const mains = (draw.mainNumbers || []).map(b => String(b.value ?? '')).join(',')
      const sp = draw.special ? String(draw.special.value ?? '') : ''
      if (`${mains}|${sp}` !== baseline.sig) return true
      const next = draw.nextDrawDeadlineMs
      if (next != null && Number.isFinite(next) && next > Date.now() + 1500) return true
      return false
    },
    clearPostDrawPoll() {
      if (this.drawPollTimerId != null) { clearInterval(this.drawPollTimerId); this.drawPollTimerId = null }
      this.drawPollGameId = null; this.drawPollBaseline = null
      this.drawPollInFlight = false; this.drawPollAttempts = 0; this.pollSlotRevealed = null
    },
    startPostDrawPollIfNeeded() {
      const game = this.activeGame
      if (!game || !game.drawRequest || !game.drawRequest.url) return
      if (this.drawPollTimerId != null) return
      this.drawPollGameId = this.activeId
      this.drawPollBaseline = this.makeDrawBaselineSnapshot(game.draw)
      this.drawPollAttempts = 0
      const pollUrl = (game.resultUrl && String(game.resultUrl).trim()) || ''
      const needsSlotBySlotReveal = /macaumarksix|^\/api\/live|\/yuexiawang/i.test(pollUrl)
      if (needsSlotBySlotReveal && !/yuexiawang/i.test(pollUrl)) {
        if (this.pollSlotRevealed == null) {
          this.pollSlotRevealed = [false,false,false,false,false,false,false]
        }
      } else if (this.pollSlotRevealed == null) {
        this.pollSlotRevealed = null
      }
      const maxAttempts = 400; const intervalMs = 1500
      const pollStopsOnlyOnOpenSeven = !!(game.resultUrl)
      const pollStopAfterMs = (() => {
        const d = this.drawPollBaseline && this.drawPollBaseline.deadlineMs
        if (d == null || !Number.isFinite(d)) return null
        return d + POST_DRAW_POLL_DEADLINE_GRACE_MS
      })()
      if (pollStopAfterMs != null && Date.now() > pollStopAfterMs) { this.clearPostDrawPoll(); return }
      const run = async () => {
        if (this.drawPollTimerId == null) return
        if (this.activeId !== this.drawPollGameId) { this.clearPostDrawPoll(); return }
        if (pollStopAfterMs != null && Date.now() > pollStopAfterMs) { this.clearPostDrawPoll(); return }
        if (this.drawPollAttempts >= maxAttempts) { this.clearPostDrawPoll(); return }
        if (this.drawPollInFlight) return
        this.drawPollInFlight = true; this.drawPollAttempts += 1
        let r = { ok: false }
        try { r = await this.fetchLatestDraw(this.activeId, { silent: true, afterDeadline: true }) }
        finally { this.drawPollInFlight = false }
        if (this.drawPollTimerId == null) return
        const g = this.activeGame
        if (r.pollComplete) { this.clearPostDrawPoll(); this.restartCountdownTimer(); return }
        if (!pollStopsOnlyOnOpenSeven && g && g.draw && this.drawPollBaseline &&
            this.isDrawUpdatedSinceBaseline(this.drawPollBaseline, g.draw)) {
          this.clearPostDrawPoll(); this.restartCountdownTimer()
        }
      }
      this.drawPollTimerId = setInterval(run, intervalMs); run()
    },

    ballTone(ball) {
      if (!ball) return 'blue'
      const t = ball.tone
      if (t === 'red' || t === 'blue' || t === 'green') return t
      return waveTone(ball.value, waveTables)
    },

    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    onDomainLoaded(domain) {
      this.siteDomain = domain || ''
    },
    onRefresh() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
      this.fetchLatestDraw()
      this.fetchBbsContent()
      this.$emit('refresh', { gameId: this.activeId })
    },
    async fetchBbsContent() {
      if (this.bbsFiles.length === 0) return
      const id = this.activeGame.bbsId
      const results = await Promise.all(
        this.bbsFiles.map(async (file) => {
          try {
            const res = await http.get('/api/bbs-proxy', {
              params: { file, id },
              responseType: 'text'
            })
            return { file, html: typeof res === 'string' ? res : (res.data || '') }
          } catch (e) {
            return { file, html: '' }
          }
        })
      )
      this.bbsPanels = results.filter(p => p.html)
    },
    openPicturePreview(item) {
      if (!item) return
      const src = this.pictureFileUrl(item.localUrl)
      if (!src) return
      this.picturePreview = { src, title: item.pictureName ? String(item.pictureName) : '' }
    },
    closePicturePreview() { this.picturePreview = null },
    syncPictureGalleryTypeFromGame() {
      this.pictureGalleryLotteryType = this.activePictureLotteryType
    },
    async initDraw() {
      const gameId = this.activeId
      await this.fetchLatestDraw(gameId)
      await this.loadPreviousDraw(gameId)
      const rev = this.current && this.current.revealed
      if (Array.isArray(rev)) {
        const count = rev.filter(Boolean).length
        if (count > 0 && count < 7) {
          this.countdownText = '00:00:00'
          this.startPostDrawPollIfNeeded()
        }
      }
    },
    preloadOtherGames() {
      const others = this.games.filter(g => g.id !== this.activeId)
      others.forEach(g => {
        this.fetchLatestDraw(g.id, { silent: true })
      })
    },
    shouldSetDraw(id, draw) {
      if (draw && Array.isArray(draw.revealed) && draw.revealed.some(Boolean)) return true
      if (!this.previousDraws[id]) return true
      return false
    },
    async loadPreviousDraw(gameId) {
      const id = gameId != null ? gameId : this.activeId
      const game = this.games.find(g => g.id === id)
      if (!game || !game.drawPageType) return
      try {
        const res = await fetchDrawsPage({ type: game.drawPageType, page: 1, size: 1 })
        const payload = extractPagePayload(res)
        const rows = (payload && payload.list) || []
        if (rows.length) {
          const row = mapRecordToRow(rows[0], 0)
          if (row) {
            this.$set(this.previousDraws, id, row)
            // 只替换号码，保留 live 的倒计时字段
            const draw = game.draw
            if (draw && draw.revealed && !draw.revealed.some(Boolean)) {
              this.$set(draw, 'mainNumbers', row.mainNumbers)
              this.$set(draw, 'special', row.special)
            } else if (draw && !draw.revealed) {
              this.$set(draw, 'mainNumbers', row.mainNumbers)
              this.$set(draw, 'special', row.special)
            }
          }
        }
      } catch (e) { console.error('loadPreviousDraw失败', e) }
    },
    pictureFileUrl(localUrl) {
      if (localUrl == null || String(localUrl).trim() === '') return ''
      const path = String(localUrl).trim()
      if (/^https?:\/\//i.test(path)) return path
      const isDev = typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'development'
      if (isDev && path.startsWith('/')) return path
      const base = (typeof process !== 'undefined' && process.env && process.env.VUE_APP_API_BASE) || 'http://localhost:9999'
      const b = String(base).replace(/\/$/, '')
      return b + (path.startsWith('/') ? path : `/${path}`)
    }
  }
}
</script>

<style scoped>
.lottery-page {
  --bg-page: #f0f4f8; --text: #1a1a1a; --red: #e02020; --green: #2e7d32;
  --radius-card: clamp(0.5rem, 2vw, 0.75rem);
  width: 100%; max-width: min(30rem, 100%); margin-left: auto; margin-right: auto;
  min-height: 100vh; background: var(--bg-page); color: var(--text);
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif; position: relative;
  padding:
    clamp(0.25rem, 1vw, 0.4rem)
    max(clamp(0.25rem, 1vw, 0.4rem), env(safe-area-inset-right, 0px))
    max(3.25rem, env(safe-area-inset-bottom, 0px))
    max(clamp(0.25rem, 1vw, 0.4rem), env(safe-area-inset-left, 0px));
}
.game-tabs {
  display: flex; gap: clamp(0.25rem, 1.5vw, 0.375rem); overflow-x: auto;
  -webkit-overflow-scrolling: touch; scrollbar-width: none;
  justify-content: center; background: linear-gradient(180deg, #e8f3fc 0%, #dceaf8 100%);
  padding: clamp(0.45rem, 2vw, 0.6rem) clamp(0.35rem, 1.8vw, 0.55rem);
  border-bottom: 1px solid rgba(94,176,255,0.4);
}
.game-tabs::-webkit-scrollbar { display: none; }
.game-tabs__btn {
  flex: 0 0 auto; min-width: auto; border: none;
  padding: clamp(0.5rem, 2.2vw, 0.625rem) clamp(0.625rem, 3vw, 0.75rem);
  font-size: clamp(0.75rem, 2.6vw, 0.8125rem); font-weight: 700; cursor: pointer;
  border-radius: var(--radius-card); transition: background 0.2s, color 0.2s;
  background: rgba(21,58,107,0.08); color: #153a6b;
}
.game-tabs__btn.is-active { background: linear-gradient(180deg, #7ec8ff 0%, #4a9eea 100%); color: #0d2d52; }
.result-card {
  margin: clamp(0.5rem, 2.5vw, 0.625rem) 0 0; background: #fff;
  border: 2px solid #5eb0ff; border-radius: clamp(0.5rem, 2.5vw, 0.75rem); padding: 0;
  overflow: hidden; box-shadow: 0 4px 14px rgba(30,107,214,0.12);
  font-family: KaiTi, STKaiti, '楷体', serif;
}
.result-card__content {
  padding: clamp(0.625rem, 3vw, 0.75rem) clamp(0.35rem, 1.8vw, 0.55rem) clamp(0.75rem, 3.2vw, 0.875rem);
}
.result-card__head {
  display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between;
  gap: clamp(0.375rem, 2vw, 0.5rem); margin-bottom: clamp(0.625rem, 3vw, 0.75rem);
}
.result-card__title { margin: 0; font-size: clamp(1rem, 4vw, 1.15rem); font-weight: 800; }
.result-card__links { font-size: clamp(0.85rem, 3.2vw, 0.9rem); }
.link-red { color: var(--red); text-decoration: none; font-weight: 700; }
.result-card__numbers-row {
  display: flex; align-items: flex-start; justify-content: space-between;
  gap: clamp(0.25rem, 1.5vw, 0.5rem);
}
.result-card__next {
  margin: clamp(0.5rem, 2.5vw, 0.625rem) 0 0; font-size: clamp(0.85rem, 3.2vw, 0.9rem);
  font-weight: 700; color: var(--red); text-align: center;
}
.result-card__next .countdown-num {
  display: inline-block; margin-left: 0.15em; font-variant-numeric: tabular-nums; letter-spacing: 0.03em;
}
.promo-green {
  margin: clamp(0.625rem, 3vw, 0.75rem) 2px 0;
  background: linear-gradient(90deg, #43a047, #66bb6a); color: #fff;
  padding: clamp(0.625rem, 3vw, 0.75rem) clamp(0.75rem, 3.5vw, 0.875rem);
  border-radius: var(--radius-card); font-size: clamp(0.75rem, 2.8vw, 0.8125rem);
  display: flex; flex-direction: column; gap: clamp(0.2rem, 1vw, 0.25rem); text-align: center;
}
.fab-refresh {
  position: fixed; right: clamp(0.75rem, 4vw, 1.25rem);
  bottom: max(3.5rem, env(safe-area-inset-bottom, 0px));
  width: clamp(2.25rem, 10vw, 2.5rem); height: clamp(2.25rem, 10vw, 2.5rem);
  border-radius: 50%; border: none; background: rgba(255,255,255,0.85);
  box-shadow: 0 2px 10px rgba(0,0,0,0.15); cursor: pointer;
  z-index: 999; padding: clamp(0.25rem, 1.2vw, 0.35rem);
  -webkit-tap-highlight-color: transparent; outline: none;
}
.fab-refresh:active { box-shadow: 0 2px 10px rgba(0,0,0,0.15); }
.fab-img { width: 100%; height: 100%; object-fit: contain; }
.bbs-panel {
  margin: clamp(0.5rem, 2.5vw, 0.625rem) 0 0;
  background: #fff;
  border: 2px solid #5eb0ff;
  border-radius: clamp(0.5rem, 2.5vw, 0.75rem);
  padding: clamp(0.5rem, 2.5vw, 0.625rem);
  overflow-x: auto;
  font-size: clamp(0.75rem, 2.8vw, 0.8125rem);
}
.bbs-panel :deep(table) {
  width: 100%;
  border-collapse: collapse;
}
.bbs-panel :deep(td) {
  padding: 0.3em 0.2em;
}
.bbs-panel :deep(.tit) {
  font-size: clamp(1.1rem, 4.5vw, 1.5625rem);
  background: linear-gradient(to right, #2196F3, #00BCD4);
  color: #faff00;
  text-align: center;
  line-height: 2.2;
  border-radius: 6px;
  font-weight: bold;
}
.bbs-panel :deep(#yjbt) {
  line-height: 2.2;
  font-size: clamp(1.05rem, 4vw, 1.3rem);
  padding: 0.4em 0;
  font-weight: 800;
  background: linear-gradient(90deg, #e02020, #ff6600, #ffcc00, #2ecc40, #0066ff, #8b00ff, #e02020);
  background-size: 200% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: rainbow-flow 2s linear infinite;
}
@keyframes rainbow-flow {
  0% { background-position: 0% 50%; }
  100% { background-position: 200% 50%; }
}

.mus55-iframe {
  width: 100%;
  height: 94.375rem;
  border: none;
}


  
  .dkzlw {}
  .dkzlw th { color: #ff0; background: #f3a404;}
  .dkzlw td {}
  .webblack { color: #ff0; background: #000;}
  .webred { color: #ff0; background: #f00;}
  .webblue { color: #ff0; background: #00f;}
  .web1,.web2 { font-weight: bold; font-size: 24px; color: #f00;}
  .fontb { font-weight: bold;}
  /*表格*/
  .table1 {}
  .table1 th,
  .table1 td { padding: 3px; text-align: center; border: solid 1px #ddd; font-size:18px}
  .table1.left td { text-align: left;}
  
.bbs-panel /deep/ .list-title {
    background: linear-gradient(transparent, #83430d);
    color: #ff0;
    text-shadow: 0px 0px 10px #f00;
    border-left: 1px solid #004400;
    border-right: 1px solid #55aaff;
    height: 40px;
    line-height: 40px;
    font-size: 24px;
    text-align: center;
    border-bottom: 1px solid #000;
    text-shadow: 1px 4px 1px rgba(0, 0, 0, .5);
    font-weight: bold;
    border-radius: 5px 5px 0 0;
}
</style>
